if (!customElements.get('tile-animated')) {

  class TileAnimated extends HTMLElement {

    constructor() {
      super();

      this.content = this.querySelector('.tile__content');
      this.isAnimated = false;

      if (this.content) {
        this.content.style.opacity = '0';
        this.content.style.transition = 'opacity 1s ease-in-out';
      }

      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      if (!this.content) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimated) {
            // Add a small delay to ensure the element is fully in view
            setTimeout(() => {
              this.animate();
              this.isAnimated = true;
            }, 100);
          }
        });
      }, {
        threshold: 0.8,
        rootMargin: '0px 0px 0px 0px'
      });

      observer.observe(this);
    }

    animate() {
      if (this.content) {
        this.content.style.opacity = '1';
      }
    }
  }

  window.TileAnimated = TileAnimated;
  customElements.define('tile-animated', TileAnimated);
}